var lastSession = JSON.parse(localStorage.getItem('lastSession') || JSON.stringify({}));
var lastUser = JSON.parse(localStorage.getItem('lastUser') || JSON.stringify({}));

export function getLastSession() {
    // console.log("returning lastSession as",lastSession);
    return lastSession;
}

export function getLastUser() {
    // console.log("returning lastUser as",lastUser);
    return lastUser;
}

export function userHasAddlDevices() {
    // console.log("userHasAddlDevices addlSerials",lastUser.addlDeviceSerials);
    if (lastUser && lastUser.addlDeviceSerials && lastUser.addlDeviceSerials.length > 0)
        return true;
    else
        return false;
}

export function getUserDeviceSerials() {
    let newArray = [lastUser.deviceSerial, ...lastUser.addlDeviceSerials];
    return newArray;
}

export function setLastSession(session) {
    lastSession.id = session.id;
    lastSession.dateTime = session.dateTime;
    lastSession.expiryDateTime = session.expiryDateTime;
    lastSession.loginId = session.loginId;
    lastSession.userInfo = session.userInfo;
    // console.log("lastSession",lastSession);
    saveLastSession();
}

export function getDashboardInfo() {
    return JSON.parse(localStorage.getItem('dashInfo'));
}

export function setDashboardInfo(dashInfo) {
    localStorage.setItem('dashInfo', JSON.stringify(dashInfo));
}

export function getDeviceSerials() {
    return JSON.parse(localStorage.getItem('deviceSerials'));
}

export function setDeviceSerials(listOfSerials) {
    localStorage.setItem('deviceSerials', JSON.stringify(listOfSerials));
}

export function setCurrentDeviceSerial(curDevSerial) {
    localStorage.setItem('currentDeviceSerial', curDevSerial);
}

export function getCurrentDeviceSerial() {
    return localStorage.getItem('currentDeviceSerial');
}

export function setUserInfo(userInfo) {
    if (!userInfo) {
        lastUser = {};
        console.log("deleted user info",lastUser);
        saveLastUser();
        return;
    }
    lastUser.id = userInfo.id;
    lastUser.firstName = userInfo.firstName;
    lastUser.lastName = userInfo.lastName;
    lastUser.emailAddress = userInfo.emailAddress;
    lastUser.mobileNumber = userInfo.mobileNumber;
    lastUser.userType = userInfo.userType;
    lastUser.active = userInfo.active;
    lastUser.emailVerified = userInfo.emailVerified;
    lastUser.regCode = userInfo.regCode;
    lastUser.deviceSerial = userInfo.deviceSerial;
    lastUser.lastKnownLat = userInfo.lastKnownLat;
    lastUser.lastKnownLang = userInfo.lastKnownLang;
    lastUser.deviceSerial = userInfo.deviceSerial;
    lastUser.addlDeviceSerials = userInfo.addlDeviceSerials;
    console.log("lastUser",lastUser);
    console.log("lastUser Lat",lastUser.lastKnownLat);
    console.log("lastUser Lang",lastUser.lastKnownLang);
    console.log("lastUser addlSerials",lastUser.addlDeviceSerials);
    saveLastUser();
}

export function saveLastSession() {
    localStorage.setItem('lastSession', JSON.stringify(lastSession));
}

export function saveLastUser() {
    localStorage.setItem('lastUser', JSON.stringify(lastUser));
}
